import { getUserUUIDPt, getUserUid, readCookieValue, updateDomain } from './utils';
import { getDeviceInfo } from './device-info-provider';
import { SessionManager } from '../../core/global-state/session';
import { getStorage } from './browser-analytics-sdk';
import { appSettingsInstance } from '../../core/global-state/global-data';
import { BrowserStorage } from './browser-storage';
import { InMemStorage } from './in-mem-storage';
import {DeviceContext} from "@mmt/events-schema"

type ReqHeaders = Record<string, string>;
const PDT_HOST = 'https://pdt.makemytrip.com';
const SEND_EVENT_ENDPOINT = '/fs/w';
const PDT_REQ_HEADERS: ReqHeaders = {
  'Content-Type': 'application/json',
  'Request-Data-Encoding': 'json',
};
const NOT_AVAILABLE = 'NA';
const DATA_SET = 'mmt_session_aero_store';

type getRequestBodyType = {
  userId: string | unknown,
  sessionManager: SessionManager
  deviceDetails: DeviceContext
}
async function getRequestBody({userId, sessionManager, deviceDetails}:getRequestBodyType) {
  const userUidResult = typeof sessionStorage !== "undefined" ? getUserUid() : null;
  let uuidPT = userId;
  if (userUidResult !== null && typeof userUidResult === 'object') {
    const {uuid, profileType} = userUidResult;
    // Use uuid and profileType as needed.
    const userIdPT = getUserUUIDPt({uuid, profile_type: profileType})
    uuidPT = userId || userIdPT;
  }

  const deviceId =  deviceDetails?.device_id || readCookieValue(document.cookie, 'dvid') || NOT_AVAILABLE;
  const devicePlatform = deviceDetails?.platform || getDeviceInfo(window)?.platform;
  const sessionId = await sessionManager.getCurrentSessionId();

  return JSON.stringify([{
    uuidPT,
    deviceId,
    value: {
      session_id: sessionId,
    },
    column: devicePlatform === 'pwa' ? 'pwa' : 'desktop',
    datasetName: DATA_SET,
  }]);
}

export const syncSessionIdToPdtDb = async (isCalled: boolean, existingSessionManager: SessionManager | undefined, existingStorage: BrowserStorage | InMemStorage | undefined): Promise<string> => {
  if (!isCalled) {
    return 'success';
  }

  const storage = existingStorage || getStorage();
  const sessionManager = existingSessionManager || new SessionManager(storage);
  const isSync = await sessionManager.getSyncStatus();
  const retryStatus = await sessionManager.getRetryStatus();
  const uuId = appSettingsInstance.getSetting("userIdPt")
  const deviceDetails = appSettingsInstance.getSetting("deviceContext");

  if (isSync || retryStatus > 6) {
    return 'success';
  }

  try {
    const PDT_SESSION_END_POINT = `${updateDomain(PDT_HOST)}${SEND_EVENT_ENDPOINT}`;
    const requestBody = await getRequestBody(<getRequestBodyType>{userId: uuId, sessionManager, deviceDetails});
    const response =  await fetch(PDT_SESSION_END_POINT, {
      method: 'POST',
      body: requestBody,
      headers: PDT_REQ_HEADERS,
      keepalive: true,
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    await sessionManager.updateSyncStatus();
    return 'success';
  } catch (error) {
    console.log('Failed to sync session ID to PDT DB:', error);
    sessionManager.updateRetryStatus();
    return 'failure';
  }
};
